/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useState, Fragment, useEffect, useRef } from 'react';
import { Grid, ListItem } from '@material-ui/core';
import { StyledListItemIcon, SelectedListItem, DefaultListItem, StyledSplitGrid, StyledSortItemDiv, DisabledListItem, SelectedSortItem, DefaultListItemAlignedWithGroupName, DisabledListItemAlignedWithGroupName, SelectedSortItemAlignedWithGroupName, SelectedListItemAlignedWithGroupName } from './DropdownList.style';
/**
 * @param options [Required] used to display the options to the dropdown list.
 * @param selectedValue [Optional] used to display selected item in the dropdown.
 * @param onSortChange [Optional] Callback method fired on Dropdown when sorting on dropdown with sortItem.
 * @param onClick [Required] callback method fired on click on list item.
 * @param isSortOptionItemApplied [optional] used to render sort item label.
 * @param isSortOptionItemClicked [optional] used to render sort item label.
 * **/
export const DropdownListItem = (props) => {
    const [selectedValue, setSelectedValue] = useState(props.selectedValue);
    const listItemRefs = useRef({});
    useEffect(() => {
        setSelectedValue(props.selectedValue);
    }, [props.selectedValue]);
    useEffect(() => {
        const listItem = listItemRefs.current[`list-item-${selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.value}`];
        if (!!selectedValue && listItem) {
            listItem.scrollIntoView(false);
        }
    }, []);
    const renderSortItemLabel = (option) => {
        return ((!!props.isSortOptionItemClicked || !!props.isSortOptionItemApplied) &&
            option === selectedValue);
    };
    const onSortClick = (selectedValue) => {
        if (props.onSortChange) {
            props.onSortChange(selectedValue);
        }
    };
    const getItem = (option, index) => {
        const sortItemLabel = option.sortItem && renderSortItemLabel(option) ? (jsx("div", { className: "right-sort", id: `sort-option-${index}` },
            option.sortItem.label,
            option.sortItem.className && (jsx(StyledListItemIcon, { className: option.sortItem.className })))) : null;
        return option.sortItem ? (jsx(StyledSplitGrid, { container: true },
            jsx("div", { id: `label-item-${index}` }, option.label),
            jsx(StyledSortItemDiv, { id: `sort-item-${index}`, onClick: () => onSortClick(option) }, sortItemLabel))) : (jsx(Grid, null, option.label));
    };
    const onClick = (event, option) => {
        event.stopPropagation();
        event.preventDefault();
        !!props.onClick && props.onClick(option);
    };
    const getListItemCss = (option, props) => {
        if (option.isDisabled) {
            return props.shouldAlignWithGroupName
                ? DisabledListItemAlignedWithGroupName
                : DisabledListItem;
        }
        else if ((selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.value) === option.value && option.sortItem) {
            return props.shouldAlignWithGroupName
                ? SelectedSortItemAlignedWithGroupName
                : SelectedSortItem;
        }
        else if ((selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.value) === option.value) {
            return props.shouldAlignWithGroupName
                ? SelectedListItemAlignedWithGroupName
                : SelectedListItem;
        }
        else {
            return props.shouldAlignWithGroupName ? DefaultListItemAlignedWithGroupName : DefaultListItem;
        }
    };
    return (jsx(Fragment, null, props.options.map((option, index) => (jsx(ListItem, { id: `list-item-${option.value}`, ref: el => (listItemRefs.current[`list-item-${option.value}`] = el), selected: selectedValue && selectedValue.value === option.value, onClick: (event) => onClick(event, option), key: option.value, value: option.value, disabled: option.isDisabled, css: getListItemCss(option, props) },
        option.iconClass && (jsx(StyledListItemIcon, { className: option.iconClass, leftIconColor: option.leftIconColor })),
        getItem(option, index))))));
};
//# sourceMappingURL=DropdownListItem.js.map